import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MdClear, MdCloseFullscreen, MdOpenInFull } from 'react-icons/md';
import { MdPushPinFilled, MdPushPinOutline } from 'components/Icons';
import './styles.scss';


const SidePanel = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={classNames({
        sidePanelContainer: true,
        sidePanelContainerOpen: props.isOpen,
        sidePanelContainerLeft: props.side === 'left',
        sidePanelContainerRight: props.side === 'right',
        sidePanelContainerExpanded: props.expandable && isExpanded,
      })}
    >
      <div className="sidePanelTitleBar">
        <div className="sidePanelTitleTextContainer">
          {props.expandable && (
            <button
              type="button"
              className="sidePanelHeaderButton sidePanelExpandButton"
              aria-label={isExpanded ? 'Restore panel width' : 'Expand panel width'}
              aria-pressed={isExpanded}
              title={isExpanded ? 'Restore panel width' : 'Expand panel width'}
              onClick={() => setIsExpanded(expanded => !expanded)}
            >
              {isExpanded ? <MdCloseFullscreen /> : <MdOpenInFull />}
            </button>
          )}
          <p className="sidePanelTitle">{props.title}</p>
          {props.isPinned !== undefined && (
            <button
              type="button"
              className="sidePanelHeaderButton sidePanelPinButton"
              aria-label={props.isPinned ? 'Unpin panel' : 'Pin panel'}
              aria-pressed={props.isPinned}
              title={props.isPinned ? 'Unpin panel' : 'Pin panel'}
              onClick={() => props.setIsPinned(!props.isPinned)}
            >
              {props.isPinned ? <MdPushPinFilled /> : <MdPushPinOutline />}
            </button>
          )}
          <button
            type="button"
            className="sidePanelHeaderButton sidePanelCloseButton"
            aria-label="Close panel"
            title="Close panel"
            onClick={props.closeSidePanel}
          >
            <MdClear />
          </button>
        </div>
      </div>
      <div className={classNames({ sidePanelContentContainer: true, sidePanelContentContainerVerticalFlex: props.vflex })}>
        {props.children}
      </div>
    </div>
  );
};

const { bool, func, string, oneOfType, arrayOf, node, oneOf } = PropTypes;
SidePanel.propTypes = {
  isOpen: bool.isRequired,
  closeSidePanel: func.isRequired,
  side: oneOf(['left', 'right']),
  children: oneOfType([
    arrayOf(node),
    node,
  ]).isRequired,
  title: string.isRequired,
  vflex: bool,
  expandable: bool,
  isPinned: bool,
  setIsPinned: func,
};

SidePanel.defaultProps = {
  vflex: false,
  expandable: false,
  side: 'right',
  isPinned: undefined,
  setIsPinned: () => {},
};

export default SidePanel;
